(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const closeSelect = (wrapper) => {
      wrapper.classList.remove('open');
      wrapper.querySelector('.custom-select-trigger')?.setAttribute('aria-expanded', 'false');
    };

    const initCustomSelects = () => {
      document.querySelectorAll('.custom-select-wrapper:not([data-localization-select-ready])').forEach((wrapper) => {
        const trigger = wrapper.querySelector('.custom-select-trigger');
        const options = wrapper.querySelectorAll('.custom-select-option');

        if (!trigger) return;

        wrapper.dataset.localizationSelectReady = 'true';

        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const shouldOpen = !wrapper.classList.contains('open');
          document.querySelectorAll('.custom-select-wrapper.open').forEach(closeSelect);
          wrapper.classList.toggle('open', shouldOpen);
          trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
        });

        options.forEach((opt) => {
          opt.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            options.forEach((option) => {
              option.classList.remove('selected');
              option.setAttribute('aria-selected', 'false');
            });

            opt.classList.add('selected');
            opt.setAttribute('aria-selected', 'true');
            trigger.querySelector('.trigger-label').textContent = opt.dataset.value.toUpperCase();
            closeSelect(wrapper);

            const localizationForm = wrapper.closest('form');
            if (!localizationForm) return;

            const tempForm = document.createElement('form');
            tempForm.method = 'POST';
            tempForm.action = localizationForm.action;

            localizationForm.querySelectorAll('input[type="hidden"]').forEach((input) => {
              const clone = input.cloneNode();
              tempForm.appendChild(clone);
            });

            const langInput = tempForm.querySelector('input[name="language_code"]') || document.createElement('input');
            langInput.type = 'hidden';
            langInput.name = 'language_code';
            langInput.value = opt.dataset.value;
            if (!langInput.parentElement) tempForm.appendChild(langInput);

            document.body.appendChild(tempForm);
            tempForm.submit();
          });
        });
      });
    };

    initCustomSelects();
    document.addEventListener('shopify:section:load', initCustomSelects);
    document.addEventListener('DOMContentLoaded', initCustomSelects, { once: true });
    document.addEventListener('click', (event) => {
      document.querySelectorAll('.custom-select-wrapper.open').forEach((wrapper) => {
        if (!wrapper.contains(event.target)) closeSelect(wrapper);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
